import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import type { FC } from 'react';
import { Controller } from 'react-hook-form';

interface RhfCheckboxFieldProps {
  label: any;
  name: string;
  control: any;
  defaultChecked: boolean;
}

const RhfCheckboxField: FC<RhfCheckboxFieldProps> = ({
  label,
  name,
  control,
  defaultChecked,
  ...rest
}: RhfCheckboxFieldProps) => {
  //TODO: error message handling
  return (
    <>
      <Box display="flex" flexDirection="column">
        <FormControlLabel
          label={label}
          control={
            <Controller
              name={name}
              control={control}
              defaultValue={!!defaultChecked}
              render={({
                field: { onChange, value },
                fieldState: { error }
              }) => (
                <>
                  <Checkbox checked={value} onChange={onChange} {...rest} />
                  {error && (
                    <FormHelperText error={!!error}>
                      {error.message}
                    </FormHelperText>
                  )}
                </>
              )}
            />
          }
        />
      </Box>
    </>
  );
};
export default RhfCheckboxField;
